'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { BasicSelect } from '@/modules/shared/components/basic-select/basic-select';
interface LabeledSelectProps {
  label: string;
  value?: string;
  onValueChange: (value: string) => void;
  options: string[];
  placeholder?: string;
  className?: string;
  'aria-label'?: string;
  matchTriggerWidth?: boolean;
}
function LabeledSelect(t0) {
  const $ = _c(16);
  const {
    label,
    value,
    onValueChange,
    options,
    placeholder,
    className,
    "aria-label": ariaLabel,
    matchTriggerWidth
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex w-full flex-col gap-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <label className="text-foreground text-sm font-medium">{label}</label>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = ariaLabel ?? label;
  let t4;
  if ($[4] !== className || $[5] !== matchTriggerWidth || $[6] !== onValueChange || $[7] !== options || $[8] !== placeholder || $[9] !== t3 || $[10] !== value) {
    t4 = <BasicSelect value={value} onValueChange={onValueChange} options={options} placeholder={placeholder} className={className} aria-label={t3} matchTriggerWidth={matchTriggerWidth} />;
    $[4] = className;
    $[5] = matchTriggerWidth;
    $[6] = onValueChange;
    $[7] = options;
    $[8] = placeholder;
    $[9] = t3;
    $[10] = value;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
export { LabeledSelect };